import { useState } from 'react';
import { readGraphicsCapabilities } from '../adapters/graphics-capabilities';
import { chooseRenderQuality, type RenderQuality } from '../policies/render-quality.policy';

let decided: RenderQuality | null = null;

/** How hard the 3D vehicle may work here, decided once per page load (probing WebGL costs a context). */
export function useRenderQuality(): RenderQuality {
  const [quality] = useState<RenderQuality>(() => {
    decided ??= chooseRenderQuality(readGraphicsCapabilities());
    return decided;
  });
  return quality;
}
